var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconKeyboardArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47126 6.45765C3.92519 5.86995 3.01786 5.84741 2.44468 6.40732C1.87151 6.96722 1.84953 7.89753 2.3956 8.48523C2.3956 8.48523 10.953 17.5544 10.9778 17.5791C11.5692 18.1587 12.5068 18.137 13.072 17.5307L21.6027 8.48532C22.1498 7.89855 22.1293 6.9682 21.5571 6.40732C20.9848 5.84643 20.0774 5.86741 19.5304 6.45417L12.2029 14.0917C12.0927 14.2066 11.909 14.2066 11.7988 14.0918L4.47126 6.45765Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconKeyboardArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-keyboard-arrow-down.f58bf8c4b9872277b064ca2ba23f473d.svg";